import { AssetCaseAttributes } from '@/types'
import { CreateAssetCaseMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreateAssetCaseMutation, AssetCaseAttributes, never, never>({
    defaultValues: {
      description: '',
      height: 0,
      length: 0,
      warehouseId: '',
      weight: 0,
      width: 0,
    },
    mutation: CreateMutation,
    resultKey: 'createAssetCase',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-3 gap-6">
        { formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' }) }
        { formBuilder.buildField({ name: 'Warehouse', field: 'warehouseId', type: 'warehouse' }) }
        { formBuilder.buildField({ name: 'Width of empty case', field: 'weight', type: 'weight' }) }
      </div>
      <div className="grid grid-cols-3 gap-6">
        { formBuilder.buildField({ name: 'Length (including wheels and handles)', field: 'length', type: 'integer' }) }
        { formBuilder.buildField({ name: 'Width (including wheels and handles)', field: 'width', type: 'integer' }) }
        { formBuilder.buildField({ name: 'Height (including wheels and handles)', field: 'height', type: 'integer' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
